<template>
    <div class="details-wrap">
        <img class="top-bg" src="@/assets/images/project/v3/top_bg.png" alt=""/>
        <div class="project-panel">
            <div class="project-name">
                {{ '南京市' }} ｜ {{ '碧桂园·翡翠谷一期' }}
            </div>
            <div class="census">
                <div class="share">
                    <img src="@/assets/images/project/v3/share_icon.png" alt="">
                    <span>{{ '3881' }}</span>
                </div>
                <div class="view">
                    <img src="@/assets/images/project/v3/look_blue.png" alt="">
                    <span>{{ '10288' }}</span>
                </div>
            </div>
            <div class="info">
                <span>{{ '120' }}㎡</span>
                <span>｜{{ '4室2厅' }}</span>
                <span>｜{{ '平层' }}</span>
                <span>｜{{ '智慧集成系统' }}</span>
            </div>
        </div>

        <div class="discuss-msg">
            “很满意史密斯好风好水这套系统，采暖升温很快，空调凉而不冷可以开一整夜，施工师傅也非常细心负责”
        </div>
        <div class="discuss-panel">
            <div class="user-box">
                <img :src="discussInfo.userInfo.img" alt="">

                <div class="name">
                    {{ discussInfo.userInfo.name }}
                </div>
                <div class="time">
                    {{ '南京' }} · {{ discussInfo.userInfo.time }}
                </div>
            </div>
            <!-- 施工 -->
            <template v-if="isUnfoldDiscuss">
                <div class="discuss-box">
                    <div class="title">
                        <p>系统施工评价</p>
                        <vantRate v-model="discussInfo.sgInfo.score" allow-half color="#ffd21e" void-icon="star"
                                  :size="16"
                                  void-color="#eee"></vantRate>
                        <p class="score">{{ discussInfo.sgInfo.score }}分</p>
                        <p class="time">{{ '2023.02.03' }}</p>
                    </div>
                    <div class="content">
                        {{ discussInfo.sgInfo.content }}
                    </div>
                    <div class="img-box">
                        <template v-for="(item,index) in discussInfo.sgInfo.img">
                            <div :class="['img-item',{'video_mask':index == 1}]">
                                <img :src="item" alt="" @click="toPreview(discussInfo.sgInfo.img,index)">
                            </div>
                        </template>
                    </div>
                    <div class="audio-box">
                        <div class="icon">
                            <img class="audio-icon audio-icon-act" src="@/assets/images/project/v3/audio_icon.png"
                                 alt="">
                        </div>
                        <div class="time">
                            {{ discussInfo.sgInfo.audio_time }}s
                        </div>
                        <div class="red-dit"></div>
                        <audio id="audio_sg" :src="discussInfo.sgInfo.audio"></audio>
                    </div>
                    <div class="split"></div>
                </div>
            </template>
            <!-- 竣工 -->
            <template v-if="isUnfoldDiscuss">
                <div class="discuss-box">
                    <div class="title">
                        <p>竣工交付评价</p>
                        <vantRate v-model="discussInfo.jgInfo.score" allow-half color="#ffd21e" void-icon="star"
                                  :size="16"
                                  void-color="#eee"></vantRate>
                        <p class="score">{{ discussInfo.jgInfo.score }}分</p>
                        <p class="time">{{ '2023.02.03' }}</p>
                    </div>
                    <div class="content">
                        {{ discussInfo.jgInfo.content }}
                    </div>
                    <div class="img-box">
                        <template v-for="(item,index) in discussInfo.jgInfo.img">
                            <div :class="['img-item',{'video_mask':index == 1}]">
                                <img :src="item" alt="" @click="toPreview(discussInfo.jgInfo.img,index)">
                            </div>
                        </template>
                    </div>
                    <div class="audio-box">
                        <div class="icon">
                            <img class="audio-icon" src="@/assets/images/project/v3/audio_icon.png" alt="">
                        </div>
                        <div class="time">
                            {{ discussInfo.jgInfo.audio_time }}s
                        </div>
                        <div class="red-dit"></div>
                        <audio id="audio_sg" :src="discussInfo.jgInfo.audio"></audio>
                    </div>
                    <div class="split"></div>
                </div>
            </template>
            <!-- 追评 -->
            <div class="discuss-box">
                <div class="title">
                    <p> {{ computTime(discussInfo.zpInfo.time) }}后追评 </p>
                    <p class="time">{{ '2023.02.03' }}</p>
                </div>
                <div class="content">
                    {{ discussInfo.zpInfo.content }}
                </div>
                <div class="img-box">
                    <template v-for="(item,index) in discussInfo.zpInfo.img">
                        <div :class="['img-item',{'video_mask':index == 1}]">
                            <img :src="item" alt="" @click="toPreview(discussInfo.zpInfo.img,index)">
                        </div>
                    </template>
                </div>
            </div>
            <div class="unfold" @click="toUnfold">
                <p> {{ isUnfoldDiscuss ? '收起评价' : '展开评论' }}</p>
                <div :class="['arrow-unfold',{'arrow':isUnfoldDiscuss}]"></div>
            </div>
        </div>
        <!-- 其他评价（本项目无评价时展示） -->
        <div class="other-panel">
            <div class="top-box">
                <div class="title">其它用户评价（{{ '214' || 0 }}）</div>
                <div class="more" @click="toMoreDiscuss">查看全部</div>
            </div>
            <div class="user-box">
                <template v-for="item in otherInfo">
                    <div class="user-item">
                        <img :src="item.img" alt=""/>
                        <p>{{ item.name }}</p>
                    </div>
                </template>
                <div class="user-item" @click="toMoreDiscuss">
                    <img src="@/assets/images/project/v3/more_icon.png" alt=""/>
                    <p>更多</p>
                </div>
            </div>
        </div>
        <!-- 施工档案 -->
        <div class="info-panel">
            <div class="title">施工档案</div>
            <div class="work-box">
                <div class="label">
                    <p>3D图纸</p>
                </div>
                <div class="more-content">
                    <div class="look-btn"  @click="toLookWord(0)">点击查看</div>
                </div>
            </div>
            <div class="work-box">
                <div class="label">
                    <p>空调隐蔽系统施工</p>
                    <div class="more-box" @click="toLookWord(1)">点击查看</div>
                </div>
                <div class="img-content">
                    <template v-for="(item,index) in arrImg">
                        <img :src="item"
                             alt="" @click="toPreview(arrImg,index)">
                    </template>
                </div>
                <div class="item-content">
                    <div class="item-box">
                        <div class="item">风机盘管验收</div>
                        <div class="item">核心阀件验收</div>
                        <div class="item">系统管路验收</div>
                        <div class="item">氟水换热器验收</div>
                    </div>
                    <img src="@/assets/images/project/v3/qualified.png" alt="">
                </div>
                <div class="split"></div>
            </div>
            <div class="work-box">
                <div class="label">
                    <p>新风系统施工</p>
                    <div class="more-box" @click="toLookWord(2)">点击查看</div>
                </div>
                <div class="img-content">
                    <template v-for="(item,index) in arrImg">
                        <img :src="item"
                             alt="" @click="toPreview(arrImg,index)">
                    </template>
                </div>
                <div class="item-content">
                    <div class="item-box">
                        <div class="item">风机盘管验收</div>
                        <div class="item">核心阀件验收</div>
                        <div class="item">系统管路验收</div>
                        <div class="item">氟水换热器验收</div>
                    </div>
                    <img src="@/assets/images/project/v3/qualified.png" alt="">
                </div>
                <div class="split"></div>
            </div>
            <div class="work-box">
                <div class="label">
                    <p>采暖隐蔽系统施工</p>
                    <div class="more-box" @click="toLookWord(3)">点击查看</div>
                </div>
                <div class="img-content">
                    <template v-for="(item,index) in arrImg">
                        <img :src="item"
                             alt="" @click="toPreview(arrImg,index)">
                    </template>
                </div>
                <div class="item-content">
                    <div class="item-box">
                        <div class="item">风机盘管验收</div>
                        <div class="item">核心阀件验收</div>
                        <div class="item">系统管路验收</div>
                        <div class="item">氟水换热器验收</div>
                    </div>
                    <img src="@/assets/images/project/v3/qualified.png" alt="">
                </div>
                <div class="split"></div>
            </div>
            <div class="work-box">
                <div class="label">
                    <p>系统竣工调试</p>
                    <div class="more-box" @click="toLookWord(4)">点击查看</div>
                </div>
                <div class="img-content">
                    <template v-for="(item,index) in arrImg">
                        <img :src="item"
                             alt="" @click="toPreview(arrImg,index)">
                    </template>
                </div>
                <div class="item-content">
                    <div class="item-box">
                        <div class="item">风机盘管验收</div>
                        <div class="item">核心阀件验收</div>
                        <div class="item">系统管路验收</div>
                        <div class="item">氟水换热器验收</div>
                    </div>
                    <img src="@/assets/images/project/v3/qualified.png" alt="">
                </div>
            </div>
        </div>
        <!-- 服务团队 -->
        <div class="info-panel">
            <div class="title">服务团队</div>
            <div class="team-box">
                <div class="team-item">
                    <img
                        :src="'https://thirdwx.qlogo.cn/mmopen/vi_32/0c7VQtfCatkQY1yDjb1bibgQ1PQtlicEGKLv5JKTVSxzgEsBDr6icIHOdKpoPhfPibmib3sPZ4mpRxfYcFhibTkibnYQg/132'"
                        alt="">
                    <div class="team-info">
                        <div class="info-box">
                            <p>李彬维</p>
                            <p>工号:{{ '0800024189' }}</p>
                            <p>项目经验：{{ 80 }}户</p>
                        </div>
                        <div class="position">
                            {{ '客户经理：为用户提供售前、售中、售后全程' }}
                        </div>
                    </div>
                </div>
                <div class="team-item">
                    <img
                        :src="'https://thirdwx.qlogo.cn/mmopen/vi_32/0c7VQtfCatkQY1yDjb1bibgQ1PQtlicEGKLv5JKTVSxzgEsBDr6icIHOdKpoPhfPibmib3sPZ4mpRxfYcFhibTkibnYQg/132'"
                        alt="">
                    <div class="team-info">
                        <div class="info-box">
                            <p>李彬维</p>
                            <p>工号:{{ '0800024189' }}</p>
                            <p>项目经验：{{ 80 }}户</p>
                        </div>
                        <div class="position">
                            {{ '项目监理：取得中国节能协会官方项目经理资格认定证书监管施工质量' }}
                        </div>
                    </div>
                </div>
                <div class="team-item">
                    <img
                        :src="'https://thirdwx.qlogo.cn/mmopen/vi_32/0c7VQtfCatkQY1yDjb1bibgQ1PQtlicEGKLv5JKTVSxzgEsBDr6icIHOdKpoPhfPibmib3sPZ4mpRxfYcFhibTkibnYQg/132'"
                        alt="">
                    <div class="team-info">
                        <div class="info-box">
                            <p>李彬维</p>
                            <p>工号:{{ '0800024189' }}</p>
                            <p>项目经验：{{ 80 }}户</p>
                        </div>
                        <div class="position">
                            {{ '项目经理：调配施工人员，监督施工进度' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 了解更多 -->
        <div class="more-panel">
            <div class="title">了解更多</div>
            <div class="product arrow" @click="toMoreProduct">
                <div class="product-link">
                    <img src="@/assets/images/project/v3/product_link.png" alt="">
                    产品详情
                </div>
                <img class="product_pic" src="@/assets/images/project/v3/product_pic.png" alt="">
                <div class="text">
                    <p>A.O.史密斯 AI-LiNK</p>
                    <p>好风好水 智慧集成</p>
                </div>

            </div>
            <div class="case arrow" @click="toMoreCase">
                <img src="@/assets/images/project/v3/case_icon.png" alt="">
                <div class="text">
                    更多案例
                </div>
            </div>
        </div>
        <img class="bottom-bg" src="@/assets/images/project/v3/bottom_bg.jpg"></img>
        <div class="staff-panel">
            <div class="staff-box">
                <img class="head" src="@/assets/images/project/v3/staff_head.png" alt=""></img>
                <div class="name">王小姐</div>
                <div class="position">高级服务顾问</div>
                <img class="qrcode"></img>
            </div>
        </div>

        <media-preview :show="isShowPreview" :nIndex="nPreviewIndex" :arrUrl="arrPreview"
                       @close="closePreview"></media-preview>
    </div>
</template>

<script>
import {Rate} from 'vant';
import mediaPreview from '../components/preview/index.vue';
import URLAPI from "@/libsV2/urlApi";

export default {
    name: "shareDetails",
    components: {
        vantRate: Rate,
        mediaPreview
    },
    data() {
        return {
            arrImg: ['https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg', 'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg', 'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg', 'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg'],
            discussInfo: {
                userInfo: {
                    img: 'https://thirdwx.qlogo.cn/mmopen/vi_32/0c7VQtfCatkQY1yDjb1bibgQ1PQtlicEGKLv5JKTVSxzgEsBDr6icIHOdKpoPhfPibmib3sPZ4mpRxfYcFhibTkibnYQg/132',
                    name: '随*5',
                    time: "2023-02-01 14:46:01"
                },
                sgInfo: {
                    content: "对比了很多家，最后选择了史密斯，服务态度非常好，刚刚装修完，不知道体验如何 ",
                    score: 4.8,
                    img: [
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg'
                    ],
                    audio: "https://pro-mixed-tt.babycdn.com/aotest/uploads/mp3/02/01/0201021356_ImI1SZSq.mp3",
                    audio_time: "13.7"
                },
                jgInfo: {
                    content: "竣工测试",
                    time: "2023-01-31 13:53:49",
                    score: 4.3,
                    audio: "https://pro-mixed-tt.babycdn.com/aotest/uploads/mp3/02/01/0201021356_ImI1SZSq.mp3",
                    audio_time: "13.7",
                    img: [
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg'
                    ]
                },
                zpInfo: {
                    content: "追评测试122",
                    time: "2023-01-31 13:54:41",
                    img: [
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg',
                        'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/discuss/1675232001Jsza.jpg'
                    ]
                }

            },
            isUnfoldDiscuss: true,
            //其他评论的用户信息
            otherInfo: [{
                img: 'https://thirdwx.qlogo.cn/mmopen/vi_32/0c7VQtfCatkQY1yDjb1bibgQ1PQtlicEGKLv5JKTVSxzgEsBDr6icIHOdKpoPhfPibmib3sPZ4mpRxfYcFhibTkibnYQg/132',
                name: '随*5'
            }, {
                img: 'https://thirdwx.qlogo.cn/mmopen/vi_32/0c7VQtfCatkQY1yDjb1bibgQ1PQtlicEGKLv5JKTVSxzgEsBDr6icIHOdKpoPhfPibmib3sPZ4mpRxfYcFhibTkibnYQg/132',
                name: '随*5'
            }, {
                img: 'https://thirdwx.qlogo.cn/mmopen/vi_32/0c7VQtfCatkQY1yDjb1bibgQ1PQtlicEGKLv5JKTVSxzgEsBDr6icIHOdKpoPhfPibmib3sPZ4mpRxfYcFhibTkibnYQg/132',
                name: '随*5'
            }, {
                img: 'https://thirdwx.qlogo.cn/mmopen/vi_32/0c7VQtfCatkQY1yDjb1bibgQ1PQtlicEGKLv5JKTVSxzgEsBDr6icIHOdKpoPhfPibmib3sPZ4mpRxfYcFhibTkibnYQg/132',
                name: '随*5'
            }, {
                img: 'https://thirdwx.qlogo.cn/mmopen/vi_32/0c7VQtfCatkQY1yDjb1bibgQ1PQtlicEGKLv5JKTVSxzgEsBDr6icIHOdKpoPhfPibmib3sPZ4mpRxfYcFhibTkibnYQg/132',
                name: '随*5'
            }],
            isShowPreview: false,
            nPreviewIndex: 0,
            arrPreview: [],
        }
    },
    methods: {
        //获取时间差
        computTime(oldTime) {
            if (oldTime == null && oldTime == undefined) {
                return '1天'
            }
            let nowTime = new Date().getTime();  //现在时间 时间戳
            let endTime = oldTime.replace(/-/g, '/');
            let zhuiTime = new Date(endTime);
            zhuiTime = zhuiTime.getTime();
            let diffTime = (nowTime - zhuiTime) / 1000
            let timeData = ''

            if (diffTime < 0) {
                timeData = '1天'
            } else if (0 < diffTime && diffTime < 86400) {
                timeData = '1天'
            } else if (86400 < diffTime && diffTime < 2592000) {
                timeData = parseInt(diffTime / 86400) + '天'
            } else if (2592000 < diffTime && diffTime < 31536000) {
                timeData = parseInt(diffTime / 2592000) + '个月'
            } else {
                timeData = parseInt(diffTime / 31536000) + '年'
            }

            return timeData
        },
        closePreview() {
            this.isShowPreview = false;
        },
        toPreview(arr, i) {
            this.arrPreview = arr.map((it) => {
                return {
                    pic: it,
                    type: 'image'
                }
            });
            this.nPreviewIndex = i;
            this.isShowPreview = true;
            console.log(this.arrPreview)
        },
        toUnfold() {
            this.isUnfoldDiscuss = !this.isUnfoldDiscuss;
        },
        toMoreProduct() {
            let param = process.env.VUE_APP_FLAG == 'production' ? `id=73&itemid=930&name=1980&project_uuid=${this.$route.query.project_uuid}` : `type=package&id=136&project_uuid=${this.$route.query.project_uuid}`;
            window.location.href = `${URLAPI.URL5}comm/scan/jumpurl?path=goods&params=${encodeURIComponent(param)}`;
        },
        toMoreCase() {
            this.$router.back(-1);
        },
        toMoreDiscuss(item) {
            this.$router.push({
                path: '/project/v3/discuss/index'
            })
        },
        toLookWord(type) {
            switch (type) {
                case 0: //3d图纸
                    break;
                case 1: //空调隐蔽系统施工
                case 2: //新风系统施工
                case 3: //采暖隐蔽系统施工
                case 4: //系统竣工调试
                    this.$router.push({
                        path: `/project/v3/word/index?type=${type}`
                    })
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
